import React, { useEffect, useState } from 'react';
import { Button, Dropdown, Input } from '@quyva/shared-ui';
import {
    faCheck,
    faClose,
    faGlobe,
    faInfoCircle,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TelegramSocketEvent } from './enums';
import { countryCodes } from './countryCodes';

const phoneMaxLength = 10;
const otpMaxLength = 5;

const CountryCodeLabel = ({ countryData, showCountry }) => {
    return (
        <div className={`flex text-texts-secondary300`}>
            {showCountry && <div className='mr-2'>{countryData.country}</div>}
            <div className='font-semibold'>+{countryData.code}</div>
        </div>
    );
};

export const AuthenticationForm = ({
    user,
    socket,
    repository,
    enableOTP,
    setShowTelegramForm,
    setIsLoading,
    setLoadingText,
    countryCode,
    setCountryCode,
    phoneNumber,
    setPhoneNumber,
}) => {
    const [countryCodeDropDown, setCountryCodeDropDown] = useState([]);
    const [otp, setOtp] = useState('');

    useEffect(() => {
        const dropDown = countryCodes.map((countryData) => {
            const data = {
                key: countryData.code,
                label: (
                    <CountryCodeLabel
                        countryData={countryData}
                        showCountry={true}
                    />
                ),
                icon: null,
                iconColor: null,
                selected: countryCode.code === countryData.code,
                action: () => {
                    setCountryCode(countryData);
                },
            };
            return data;
        });

        setCountryCodeDropDown(dropDown);
    }, [countryCode]);

    return (
        <div className='w-full h-full flex flex-col'>
            <div className='flex items-center'>
                <div className='w-1/2 font-semibold text-texts-secondary300'>
                    <label htmlFor='phoneNumber'>Telegram Number</label>
                </div>

                <div className='w-full'>
                    <div className='relative flex items-center'>
                        <Dropdown
                            dropDownList={countryCodeDropDown}
                            showButtonText={true}
                            buttonText={
                                <CountryCodeLabel
                                    countryData={countryCode}
                                    showCountry={false}
                                />
                            }
                            titleText={null}
                            buttonHoverText={'Select Font'}
                            buttonClassName={
                                'text-texts-tertiary400 mr-2 h-8 w-24'
                            }
                            listClassName={''}
                            listTitleText={
                                <>
                                    <FontAwesomeIcon
                                        icon={faGlobe}
                                        className='mr-2 text-texts-secondary300'
                                    />
                                    <span>Country Codes</span>
                                </>
                            }
                            disabled={enableOTP}
                            placement={'left'}
                        />
                        <Input
                            type={'number'}
                            value={phoneNumber}
                            placeholder={'Phone number'}
                            disabled={enableOTP}
                            onChange={(e) => {
                                const value = e.target.value;
                                if (value.length <= phoneMaxLength) {
                                    setPhoneNumber(value);
                                }
                            }}
                        />
                    </div>
                </div>
            </div>

            {!enableOTP && (
                <div className='flex w-full items-center text-sm mt-3'>
                    <FontAwesomeIcon
                        icon={faInfoCircle}
                        className='mr-2 text-texts-tertiary400'
                        title='Information'
                    />
                    <span>
                        Please enter your telegram phone number along with
                        international phone code from dropdown
                    </span>
                </div>
            )}

            {enableOTP && (
                <div className='flex items-center mt-6'>
                    <div className='w-1/2 font-semibold text-texts-secondary300'>
                        <label htmlFor='otp'>One Time Password</label>
                    </div>

                    <div className='w-full'>
                        <div className='relative'>
                            <Input
                                type={'number'}
                                value={otp}
                                disabled={false}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (value.length <= otpMaxLength) {
                                        setOtp(value);
                                    }
                                }}
                            />
                        </div>
                    </div>
                </div>
            )}

            <div className='w-full flex justify-end items-center mt-8'>
                <Button
                    text={'Cancel'}
                    icon={faClose}
                    type={'danger'}
                    hoverText={'Cancel Telegram Integration'}
                    onClick={() => {
                        setShowTelegramForm(false);
                    }}
                    className='mr-6'
                />
                <Button
                    text={'Verify'}
                    icon={faCheck}
                    type={'success'}
                    hoverText={
                        enableOTP
                            ? 'Verify One Time Password'
                            : 'Verify Telegram Phone Number'
                    }
                    onClick={() => {
                        setLoadingText(
                            enableOTP
                                ? 'Verifying OTP...'
                                : 'Verifying Phone Number...'
                        );
                        setIsLoading(true);

                        const data = {
                            userMail: user.email,
                            repoName: repository.name,
                            repoId: repository.repoid,
                        };
                        if (enableOTP) {
                            data.otp = otp;
                            socket.emit(TelegramSocketEvent.VERIFY_OTP, data);
                        } else {
                            data.countryCode = countryCode.code;
                            data.phoneNumber = phoneNumber;
                            socket.emit(
                                TelegramSocketEvent.VERIFY_PHONE_NUMBER,
                                data
                            );
                        }
                    }}
                    disabled={
                        enableOTP
                            ? !otp || otp.length < otpMaxLength
                            : !phoneNumber ||
                              phoneNumber.length < phoneMaxLength
                    }
                />
            </div>
        </div>
    );
};
